const { get } = require('jquery');

(() => {
  angular.module('app').controller('host.views.forms.formDetails', FormDetailsControllerController);

  FormDetailsControllerController.$inject = [
    '$scope',
    '$stateParams',
    '$state',
    'abp.services.app.formTemplate',
    'abp.services.app.commonLookup',
    'Hms.FormTemplates.FormNames',
    'Hms.FormTemplates.TargetUserType',
  ];

  function FormDetailsControllerController(
    $scope,
    $stateParams,
    $state,
    formTemplateSvc,
    commonLookupSvc,
    enumFormNames,
    enumTargetUserType
  ) {
    const vm = this;
    const guidEmpty = '00000000-0000-0000-0000-000000000000';
    vm.formId = $stateParams.formTemplateId || guidEmpty;
    vm.loading = 0;
    vm.saving = 0;
    vm.isCreate = vm.formId === guidEmpty;
    vm.isEdit = false;
    vm.getDisplayServiceType = '';

    // List of all service types nameValueDto

    vm.serviceTypes = [];

    // New attachment to be uploaded

    vm.newAttachments = [];

    // Existing attachments

    vm.oldAttachments = [];

    vm.enums = {};
    vm.enums.formNames = enumFormNames;
    vm.enums.targetUserType = enumTargetUserType;

    const fileExtensions = `|${angular
      .module('app')
      .consts.fileUpload.imageExtensions.concat(
        angular.module('app').consts.fileUpload.pdfExtensions
      )
      .join('|')}|`;

    vm.toggleEdit = toggleEdit;
    vm.save = save;
    vm.cancel = cancel;
    vm.getDisplayCountry = getDisplayCountry;

    init();

    function init() {
      getAllServiceTypes();
      getFormTemplate();
      getEligibleCountries();
    }

    function getFormTemplate() {
      vm.loading += 1;
      formTemplateSvc
        .getFormTemplateForEdit({
          id: vm.formId,
        })
        .success((data) => {
          vm.form = data;
          vm.form.name = vm.form.name !== 0 ? vm.form.name : null;
          vm.form.targetUserType = vm.form.targetUserType !== 0 ? vm.form.targetUserType : null;
          vm.getDisplayServiceType = getDisplayServiceType(vm.form.serviceType);
          vm.oldAttachments = vm.form.attachments;

          // DeepCopy for Reverting Changes

          vm.formOri = angular.copy(data);
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    // Retrieve all service types from backend

    function getAllServiceTypes() {
      formTemplateSvc.getAllServiceTypes().success((data) => {
        vm.serviceTypes = data.items;
      });
    }

    // To get the name of the service type based on the value(integer type)

    function getServiceType(serviceType) {
      // eslint-disable-next-line no-var, no-redeclare
      var serviceType = _.find(vm.serviceTypes, ['value', serviceType]);
      return serviceType.name;
    }

    // Get the string of the form's service types

    function getDisplayServiceType(list) {
      return _.map(list, getServiceType).toString();
    }

    // Check if the form is valid

    function validateForm() {
      const form = $scope.formDetails;
      if (vm.isCreate) vm.hasAttachment = vm.newAttachments.length !== 0;
      if (vm.isEdit)
        vm.hasAttachment = vm.newAttachments.length !== 0 || vm.oldAttachments.length !== 0;
      return !!(App.isFormValid(form) && vm.hasAttachment);
    }

    function toggleEdit(flag) {
      vm.isEdit = flag;
    }

    // Upload new attachement

    vm.uploadConfig = {
      objectType: 'FormAttachment',
      itemsLimit: 1,
      accept: 'image/*,application/pdf',
      filters: [
        {
          name: 'fileFilter',
          fn(n) {
            const t = `|${n.type.slice(n.type.lastIndexOf('/') + 1)}|`;
            if (fileExtensions.indexOf(t) === -1) {
              abp.message.warn(App.localize('File_Warn_FileType'));
              return false;
            }
            return true;
          },
        },
        {
          name: 'sizeFilter',
          fn(n) {
            const sizeLimit = 52428800;
            if (n.size > sizeLimit) {
              abp.message.warn(App.localize('File_Warn_XSizeLimit', sizeLimit / 1024 / 1024));
              return false;
            }
            return true;
          },
        },
      ],
    };

    // Save the form template

    function save() {
      if (!validateForm()) return;
      vm.saving += 1;
      vm.form.attachments = vm.oldAttachments;
      vm.form.newAttachments = vm.newAttachments;
      formTemplateSvc
        .createOrUpdateFormTemplate(vm.form)
        .success(() => {
          abp.notify.info(App.localize('SuccessfullySaved'));
          $state.go('host.form');
        })
        .finally(() => {
          vm.saving -= 1;
        });
    }

    // Cancel Button

    function cancel() {
      if (vm.isEdit) {
        vm.toggleEdit(false);
        vm.form = angular.copy(vm.formOri);
      } else if (vm.isCreate) {
        $state.go('host.form');
      }
    }

    // Get all eligible countries for the form

    function getEligibleCountries() {
      vm.loading += 1;
      commonLookupSvc
        .getEligibleCountries()
        .success((data) => {
          vm.countries = data;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function getDisplayCountry(countryCode) {
        if (!countryCode) return '';
        const country = _.find(vm.countries, ['code', countryCode]);
        return country.name;
    }
  }
})();
